import { useInfiniteQuery } from '@tanstack/react-query'

import { scenariosCalculationLogsClient } from '@/api'
import { useDebouncedValue } from '@/hooks'

const PAGE_SIZE = 10

export const useFetchScenarioCalculationLogs = (searchQuery: string) => {
  const searchQueryDebounced = useDebouncedValue(searchQuery, 500)

  const calculationLogsQuery = useInfiniteQuery({
    queryKey: [
      scenariosCalculationLogsClient.QUERY_KEY,
      { searchQuery: searchQueryDebounced }
    ],
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      scenariosCalculationLogsClient.getLogs(
        pageParam,
        PAGE_SIZE,
        searchQueryDebounced
      ),
    getNextPageParam: (_, allPages) => allPages.length
  })

  const allPagesItems =
    calculationLogsQuery.data?.pages.reduce((prev, next) => [
      ...prev,
      ...next
    ]) || []

  const hasMorePages = allPagesItems.length % PAGE_SIZE === 0

  return {
    hasMorePages:
      hasMorePages &&
      !calculationLogsQuery.isFetching &&
      !!allPagesItems.length,
    fetchNextPage: () => calculationLogsQuery.fetchNextPage(),
    isFetching: calculationLogsQuery.isFetching,
    allPagesItems
  }
}
